import { Component, signal } from '@angular/core';

// EZ
import { DocMeta } from '@template-ui/decorators';
import { UiLibraryModule } from '@template-ui/template-ui.module';
import { EzFormInputType, InputConfig } from '@template-ui/types';

@DocMeta({
  showcaseTitle: "Simple panel with just a title and some content",
  showcaseDesc:"This sample shows a very basic panel with a title. It is collapsible",
  hide: true
})
@Component({
    selector: 'ui-panel.sample.ts, ez-panel.sample.ts',
    imports: [UiLibraryModule],
    templateUrl: './EzPanelSampleComponent.sample.html',
    styleUrl: './EzPanelSampleComponent.sample.scss'
})
export class EzPanelSampleComponent {
  // For use with 2-way binding to collapsed
  isCollapsed: boolean = false;
  toggleFormValues = signal<{ isToggleable?: boolean }>({ isToggleable: true });

  readonly toggleFormConfig: InputConfig[] = [
    {
      type: EzFormInputType.CHECKBOX,
      name: 'isToggleable',
      label: 'Panel is toggleable',
      width: '2x',
    },
  ];
}
